export const LAUNCH_ERROR_MESSAGE = 'Unable to launch ticket creation. Please try again.';

export const SUBMIT_SUCCESS_TITLE = 'Success';
export const SUBMIT_FAILURE_TITLE = 'Error';
export const SUBMIT_FAILURE_MESSAGE =
  'There was an error while submitting your ticket. Please try submitting another ticket again.';

export const formatSubmitSuccessMessage = ticketId => {
  const normalizedTicketId = String(ticketId ?? '').replace(/^#+/, '');

  return `Ticket ${normalizedTicketId} has been successfully created. You can close the window now.`;
};
